import { css, jsx } from '@emotion/core';
import { Icon } from 'antd';
import React from 'react';

import Heading from '@/src/shared/components/Heading';
import Link from '@/src/shared/components/Link';
import { colors } from '@/styles';

const style = {
  container: css`
    margin: 1.2rem 0 0;
  `,
  link: css`
    align-items: center;
    color: ${colors.secondaryBlue};
    display: inline-flex;

    .anticon {
      color: inherit;
      font-size: 22px;
      margin: 0 0.9rem 0 0;
    }
  `,
};

const ContactCTA = () => {
  return (
    <div>
      <Heading type={3} theme="primaryGray" weight="bolder">
        Have a question about this document?
      </Heading>
      <div css={style.container}>
        <Link href="/about/ask-us/" css={style.link}>
          <Icon type="mail" />
          Ask Us
        </Link>
      </div>
    </div>
  );
};

export default ContactCTA;
